import "./Spinner.scss"
import { spiner } from "../../service/image"

const Spinner = ( { className } ) => {


    return (
        <section className={`spinner ${className || ""}`}>
            <h3>Loading...</h3>
            <img  src={spiner} alt="Loader..." />
        </section>
    )
}

export default Spinner